import React from 'react';
import clsx from 'clsx';

const sizes = {
  sm: 'px-3 py-1.5 text-xs h-8',
  md: 'px-3.5 py-2 text-sm h-9',
  lg: 'px-4 py-2.5 text-base h-10',
};

export function Input({
  label,
  error,
  className,
  containerClassName,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  size = 'md',
  ...props
}) {
  return (
    <div className={clsx('w-full', containerClassName)}>
      {label && (
        <label className="block text-sm font-medium text-slate-600 mb-1.5">
          {label}
        </label>
      )}
      <div className="relative">
        {LeftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            <LeftIcon className="w-4 h-4" />
          </div>
        )}
        <input
          className={clsx(
            'w-full bg-white border rounded text-slate-800 placeholder-slate-400 transition-colors duration-100',
            'focus:outline-none focus:ring-1',
            // Hide number input spinners
            '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none',
            error
              ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
              : 'border-slate-300 focus:border-wrg-blue-500 focus:ring-wrg-blue-500',
            sizes[size],
            LeftIcon && 'pl-9',
            RightIcon && 'pr-9',
            className
          )}
          {...props}
        />
        {RightIcon && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
            <RightIcon className="w-4 h-4" />
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

export function Select({
  label,
  error,
  className,
  containerClassName,
  children,
  size = 'md',
  ...props
}) {
  return (
    <div className={clsx('w-full', containerClassName)}>
      {label && (
        <label className="block text-sm font-medium text-slate-600 mb-1.5">
          {label}
        </label>
      )}
      <select
        className={clsx(
          'w-full bg-white border rounded text-slate-800 transition-colors duration-100 cursor-pointer appearance-none',
          'focus:outline-none focus:ring-1',
          'bg-[url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3E%3Cpath stroke=\'%236B7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3E%3C/svg%3E")] bg-[length:1.25em_1.25em] bg-[right_0.5rem_center] bg-no-repeat pr-8',
          error
            ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
            : 'border-slate-300 focus:border-wrg-blue-500 focus:ring-wrg-blue-500',
          sizes[size],
          className
        )}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

export function Textarea({
  label,
  error,
  className,
  containerClassName,
  ...props
}) {
  return (
    <div className={clsx('w-full', containerClassName)}>
      {label && (
        <label className="block text-sm font-medium text-slate-600 mb-1.5">
          {label}
        </label>
      )}
      <textarea
        className={clsx(
          'w-full bg-white border rounded px-3.5 py-2.5 text-sm text-slate-800 placeholder-slate-400 transition-colors duration-100 resize-none',
          'focus:outline-none focus:ring-1',
          error
            ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
            : 'border-slate-300 focus:border-wrg-blue-500 focus:ring-wrg-blue-500',
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}
